import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13.222 7.333q-2.757 0-6.818.318a3.89 3.89 0 0 0-3.576 3.602 71 71 0 0 0-.161 4.97q0 2.695.16 4.969a3.89 3.89 0 0 0 3.577 3.602q4.055.317 6.818.317t6.818-.317a3.89 3.89 0 0 0 3.576-3.602q.047-.65.08-1.335l3.225 1.613a1.667 1.667 0 0 0 2.412-1.49v-7.516a1.667 1.667 0 0 0-2.412-1.49l-3.226 1.613q-.032-.685-.079-1.334A3.89 3.89 0 0 0 20.04 7.65q-4.06-.318-6.818-.318",
      clipRule: "evenodd"
    }
  )
);
var SvgVideoFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var VideoFilled_default = SvgVideoFilled;

export { VideoFilled_default as default };
